import React from "react";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <div className="p-tabview-panels" data-pc-section="panelcontainer">
        <div
          id="pr_id_10560_content"
          className="p-tabview-panel"
          role="tabpanel"
          aria-labelledby="pr_id_1056_header_0"
          data-pc-name=""
          data-pc-section="content"
        >
          <div className="pl-2">
            <h2 className="font-serif-italic !text-[28px] pb-2 !leading-[26px]">
              UK Delivery Charges
            </h2>
            <div className="my-4">
              <div className="tab-content inline-block w-[calc(100%_-_270px)] 2xl_w-[calc(100%_-_350px)]">
                <div className="pl-[26px] right-0">
                  <div className="richContent-root-63a">
                    <p>
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        Standard delivery takes between 2-4 working days, with
                        deliveries made Monday to Friday.
                      </span>
                    </p>
                    <p>&nbsp;</p>
                    <p>
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        Please note, all orders, excluding fresh food and
                        flowers (and alcohol for Northern Ireland) to the
                        following postcodes can only be dispatched by standard
                        delivery:&nbsp;
                      </span>
                    </p>
                    <p>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        AB31, AB33 to AB56,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        BT1 to BT17, BT29,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        FK17 to FK21,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        HS1 to HS9,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        IM, IV1 to IV56, IV63,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        KA27, KA28, KW1 to KW3, KW5 to KW17,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        PA2, PA20 to PA49, PA60 to PA78, PH15 to PH26,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        PH30 to PH44, PH49, PH50,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        TR21 to TR25,&nbsp;
                      </span>
                      <br />
                      <span
                        style={{ fontSize: 16, fontFamily: "Helvetica Neue, Arial, sans-serif" }}
                      >
                        ZE1 to ZE3
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Delivery;
